module.exports = __webpack_public_path__ + "media/images/fp_logo-f7bc7f3d91cb2bd604948a7a8aa9746b.png";